import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeView from "./components/HomeView";
import GalleryView from "./components/GalleryView";
import NavbarView from "./components/NavbarView";
import NoisePadPrivacyPolicy from "./components/NoisePadPrivacyPolicy";

function App() {
  return (
    <Router>
      <NavbarView/>
      <Routes>
        <Route path="/" element={<HomeView />} />
        <Route path="/gallery" element={<GalleryView />} />
        <Route path="/NoisePadPrivacyPolicy" element={<NoisePadPrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
